module.exports = __webpack_public_path__ + "static/img/logo88.f3e71e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo88.png
// module id = 8KY6
// module chunks = 1